import { render, staticRenderFns } from "./DocumentDetailPDF.vue?vue&type=template&id=11219b2e&scoped=true"
import script from "./DocumentDetailPDF.vue?vue&type=script&lang=js"
export * from "./DocumentDetailPDF.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetailPDF.vue?vue&type=style&index=0&id=11219b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11219b2e",
  null
  
)

export default component.exports